import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@zg-rentals/react-query5';

import { WizardContext } from '../../../../components/Wizard/context';

import { useSelector } from '../../../../selectors/useSelector';

import wizardActions from '../../../../components/Wizard/actions';
import PropertiesActions from '../../../../actions/PropertiesActions';
import { GET_LISTING_RECS } from '../../../../constants/RecommendationsConstants';
import AddEditPhoneNumber from '../../../../components/AddEditPhoneNumber';

const PhoneNumberFormField = (): JSX.Element => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { reducerWizardDispatch } = useContext(WizardContext);

  const currentProperty = useSelector((state) => state.properties.currentProperty);

  // @ts-expect-error
  const updateCurrentProperty = (data) => {
    dispatch(PropertiesActions.updateCurrentProperty({ contactPhone: data.contactPhone }));
    queryClient.invalidateQueries({ queryKey: [GET_LISTING_RECS] });
  };

  const updateFetchingStatus = (isFetching = false) => {
    wizardActions.updateIsFetchingData({ reducerWizardDispatch, isFetchingData: isFetching });
  };

  return (
    <AddEditPhoneNumber
      phoneData={currentProperty}
      onPhoneNumberSave={updateCurrentProperty}
      updateFetchingStatus={updateFetchingStatus}
    />
  );
};

export default PhoneNumberFormField;
